import * as z from "zod"
import { CompleteDBBranchWarehouseAreas, RelatedDBBranchWarehouseAreasModel, CompleteDBWarehouseSubzones, RelatedDBWarehouseSubzonesModel, CompleteDBWarehouseRacks, RelatedDBWarehouseRacksModel } from "./index"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const DBWarehouseFloorsModel = z.object({
  id: z.string(),
  warehouseAreaId: z.string(),
  subzoneId: z.string(),
  code: z.number().int(),
  displayName: z.string(),
  qrCode: z.string(),
  description: z.string(),
  settings: jsonSchema,
  meta: jsonSchema,
})

export interface CompleteDBWarehouseFloors extends z.infer<typeof DBWarehouseFloorsModel> {
  warehouseArea: CompleteDBBranchWarehouseAreas
  subzone: CompleteDBWarehouseSubzones
  racks: CompleteDBWarehouseRacks[]
}

/**
 * RelatedDBWarehouseFloorsModel contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
export const RelatedDBWarehouseFloorsModel: z.ZodSchema<CompleteDBWarehouseFloors> = z.lazy(() => DBWarehouseFloorsModel.extend({
  warehouseArea: RelatedDBBranchWarehouseAreasModel,
  subzone: RelatedDBWarehouseSubzonesModel,
  racks: RelatedDBWarehouseRacksModel.array(),
}))
